import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService, MFA } from '@shared/services/auth.service';
import { DASHBOARD_ROUTE } from '../../app-routing.constants';
import { Injectable } from '@angular/core';

const MFA_ROUTE = 'mfa';
@Injectable({ providedIn: 'root' })
export class MfaOrganizationGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkMfa(state.url);
  }
  private isMfaRoute(url: string): boolean {
    const tree = this.router.parseUrl(url);
    const firstSegment = tree.root.children['primary']?.segments[0]?.path;
    return firstSegment === MFA_ROUTE;
  }

  private checkMfa(url: string): boolean | UrlTree {
    const mfa = this.auth.user?.mfa;
    const hasMfaMethod = mfa != null && mfa !== MFA.NONE;
    const mfaBlocking = !!this.auth.currentOrganization?.requireMfa && !hasMfaMethod;
    const onMfaRoute = this.isMfaRoute(url);

    if (mfaBlocking) {
      return onMfaRoute ? true : this.router.createUrlTree(['/' + MFA_ROUTE]);
    }

    if (onMfaRoute) {
      return this.router.createUrlTree([DASHBOARD_ROUTE]);
    }

    return true;
  }
}
